export type MapMarker = {
  markerId: string;
  latLng: [number, number];
  content?: string;
  markerIconUrl?: string;
  iconSize?: [number, number];
  iconAnchor?: [number, number];
  popupAnchor?: [number, number];
};

export function incidentMarker(markerId: string, latLng: [number, number]): MapMarker {
  return { markerId, latLng, markerIconUrl: 'Images/Icons/map-incident.svg' };
}

export function callerMarker(markerId: string, latLng: [number, number]): MapMarker {
  return {
    markerId,
    latLng,
    markerIconUrl: 'Images/Icons/map-caller.svg',
    iconSize: [45, 62],
    iconAnchor: [22, 62],
    popupAnchor: [0, -62],
  };
}
